import * as Types from '@haaretz/s-fragments/Types';


/**
 * -----------------------------------------------------------------------------
 * ⚠️  AUTO-GENERATED FILE - DO NOT EDIT MANUALLY ⚠️
 * -----------------------------------------------------------------------------
 * This file was automatically generated by GraphQL Codegen.
 * Any manual changes will be overwritten.
 * -----------------------------------------------------------------------------
 */

export type HtmlNodeFragment = (
  { content: string, as: Types.HtmlNodeTags }
  & { __typename: 'HtmlNode' }
);


export type HtmlNodeFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const HtmlNodeFragmentGql = `
    fragment HtmlNodeFragment on HtmlNode {
  __typename
  as: tag
  content
}
    `;